module.exports = require('./helpers/bundle-url').getBundleURL('9U9Lq') + "background-bottom.7b033fd9.svg";